import { call, put, takeLatest } from 'redux-saga/effects';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { setErrorCode } from '../redux/Actions/ErrorAction';
import { UPDATE_CUSTOMER_INFO, UPDATE_CUSTOMER_INFO_ERROR, UPDATE_CUSTOMER_INFO_SUCCESS, DELETE_CUSTOMER_ACCOUNT, DELETE_CUSTOMER_ACCOUNT_SUCCESS, DELETE_CUSTOMER_ACCOUNT_ERROR, MARKETING_PREFERENCE, MARKETING_PREFERENCE_SUCCESS, MARKETING_PREFERENCE_FAILURE, UPDATE_EXTERNAL_CUSTOMER_ID, } from '../constants';
import { getCustomerInfo } from '../redux/Actions/OrderservAction';
import AuthManager from '../auth/AuthManager';
import SharedUtils from '../utils/SharedUtils';
export function* responseSuccess(payload) {
    const { body } = payload;
    //MVP
    if (!body.isSopac) {
        yield put({
            type: UPDATE_CUSTOMER_INFO_SUCCESS,
            response: payload?.body,
        });
        payload?.sucessCallback && payload?.sucessCallback(payload.body);
    } //MLP
    else if (SharedUtils.checkAllTrue([body.isSopac, body.otpValidationRequired, body.otp === ''])) {
        payload.sucessCallback && payload.sucessCallback(payload.body);
        yield put({
            type: UPDATE_CUSTOMER_INFO_SUCCESS,
        });
    }
    else {
        yield put({
            type: UPDATE_CUSTOMER_INFO_SUCCESS,
            response: payload?.body,
        });
        payload.sucessCallback && payload.sucessCallback(payload.body);
    }
}
export function* updateCustomerInformation(action) {
    const { payload } = action;
    try {
        const response = yield call(invokeApi, networkConfig.updateAccount, { queryProps: { customerId: payload.customerId } }, {
            'x-tenant-id': payload?.tenantId,
            'x-is-registered-user': 'true',
            'x-user-id': payload.customerId,
            Authorization: payload?.token,
        }, payload?.body);
        if (response.status >= 400) {
            const { body } = payload;
            if (response.status === 400 && body.isSopac) {
                payload.errorCallBack && payload.errorCallBack();
                yield put({
                    type: UPDATE_CUSTOMER_INFO_ERROR,
                });
            }
            else {
                yield put(setErrorCode(response.status));
            }
        }
        else if (response.status === 200) {
            yield* responseSuccess(payload);
        }
        else {
            yield put({
                type: UPDATE_CUSTOMER_INFO_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: UPDATE_CUSTOMER_INFO_ERROR,
        });
    }
}
export function* updateCustomerInfoSaga() {
    yield takeLatest(UPDATE_CUSTOMER_INFO, updateCustomerInformation);
}
export function* deleteCustomerAccount(action) {
    const { payload } = action;
    try {
        const authManager = AuthManager.getInstance();
        const { status } = yield call(invokeApi, networkConfig.deleteAccount, { queryProps: { customerId: authManager.customerId } }, {
            'x-tenant-id': payload?.tenantId,
            'x-is-registered-user': 'true',
            'x-user-id': authManager.customerId,
        });
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (status === 200) {
            yield put({
                type: DELETE_CUSTOMER_ACCOUNT_SUCCESS,
            });
            authManager.logout();
        }
    }
    catch (error) {
        yield put({
            type: DELETE_CUSTOMER_ACCOUNT_ERROR,
        });
    }
}
export function* deleteCustomerAccountSaga() {
    yield takeLatest(DELETE_CUSTOMER_ACCOUNT, deleteCustomerAccount);
}
export function* updateExternalCustomerId(action) {
    const { payload } = action;
    try {
        const authManager = AuthManager.getInstance();
        yield call(invokeApi, networkConfig.updateExternalCustomerId, { queryProps: { customerId: authManager.customerId, externalCustomerId: payload.externalCustomerId } }, {
            'x-tenant-id': payload?.tenantId,
            'x-is-registered-user': 'true',
            'x-user-id': authManager.customerId,
        });
    }
    catch (error) {
        console.log('Update External customer id failed', error);
    }
}
export function* updateExternalCustomerIdSaga() {
    yield takeLatest(UPDATE_EXTERNAL_CUSTOMER_ID, updateExternalCustomerId);
}
export function* addMarketingPreference(data) {
    const { payload = {} } = data;
    try {
        const response = yield call(invokeApi, networkConfig.marketingPreference, { queryProps: { customerId: payload.customerId } }, {
            'x-tenant-id': payload?.tenantId,
            'Content-Type': 'application/json',
            'x-is-registered-user': 'true',
            'x-user-id': payload.customerId,
        }, payload?.body);
        if (response.status >= 400) {
            yield put(setErrorCode(response.status));
        }
        else {
            const customerPayload = {
                customerId: payload?.customerId,
                tenantId: payload?.tenantId,
                phoneNumber: payload?.phoneNumber,
                updateUserData: true,
            };
            yield put({
                type: MARKETING_PREFERENCE_SUCCESS,
                response: payload?.body,
            });
            yield put(getCustomerInfo(customerPayload));
        }
    }
    catch (error) {
        yield put({
            type: MARKETING_PREFERENCE_FAILURE,
        });
    }
}
export function* marketingPreferenceSaga() {
    yield takeLatest(MARKETING_PREFERENCE, addMarketingPreference);
}
